export default "__VITE_ASSET__f4fa61c7__"